import { LocationQuery } from 'vue-router';
import { cacheFirstConfig, http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { TransportMethod } from './transport-method.interface';

export class TransportMethodService {
   async getTransportMethods(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<TransportMethod>>>(`/transport-methods`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
